import * as t from "io-ts";
import { UUID as uuidCodec } from "io-ts-types/UUID";

import { makeRouteSpec } from "..";
import { stringEnumCodec } from "../../codecs";
import { nonprofitEntityMetadataCodec } from "../../codecs/nonprofit";
import { HttpMethod } from "../../helpers/http";

export enum AutoApproveReason {
  DOMAIN_MATCH = "DOMAIN_MATCH",
}

export const nonprofitAdminEntityMetadataCodec = t.partial({
  notes: t.string,
  autoApproveReason: stringEnumCodec({
    name: "autoApproveReason",
    enumObject: AutoApproveReason,
  }),
  adminWelcomeFirstVisitDate: t.string,
  adminWelcomeVisitCount: t.number,
  adminWelcomeLastVisitDate: t.string,
  lastSeenBlogPostDate: t.string,
});

export type NonprofitAdminEntityMetadata = t.TypeOf<
  typeof nonprofitAdminEntityMetadataCodec
>;

export const listNonprofitAdminRequestsRouteSpec = makeRouteSpec({
  path: "/nonprofitAdminRequest/list",
  method: HttpMethod.GET,
  authenticated: true,
  tokensCodec: t.type({}),
  paramsCodec: t.type({}),
  bodyCodec: t.type({}),
  responseBodyCodec: t.array(
    t.type({
      createdAt: t.string,
      status: t.string,
      id: t.string,
      updatedAt: t.string,
      userId: t.string,
      email: t.string,
      firstName: t.union([t.string, t.null]),
      lastName: t.union([t.string, t.null]),
      username: t.union([t.string, t.null]),
      contactEmail: t.union([t.string, t.null]),
      nonprofitId: t.string,
      ein: t.union([t.string, t.null]),
      ["Nonprofit Name"]: t.union([t.string, t.null]),
      primarySlug: t.string,
      ["Nonprofit Profile"]: t.string,
      websiteUrl: t.union([t.string, t.null]),
      ["Stripe Status"]: t.union([t.string, t.null]),
      ["Auto Approve Reason"]: t.union([t.string, t.null]),
      ["Nonprofit Metadata"]: t.union([nonprofitEntityMetadataCodec, t.null]),
    })
  ),
});

export const approveAndEmailRouteSpec = makeRouteSpec({
  path: "/nonprofitAdminRequest/approveAndEmail",
  method: HttpMethod.POST,
  authenticated: true,
  tokensCodec: t.type({}),
  paramsCodec: t.type({}),
  bodyCodec: t.type({
    id: uuidCodec,
    userId: uuidCodec,
    primarySlug: t.string,
    nonprofitName: t.string,
    firstName: t.string,
    lastName: t.string,
    email: t.string,
    adminEmail: t.string,
    username: t.string,
    metadata: nonprofitAdminEntityMetadataCodec,
  }),
  responseBodyCodec: t.type({}),
});

export const rejectAndEmailRouteSpec = makeRouteSpec({
  path: "/nonprofitAdminRequest/rejectAndEmail",
  method: HttpMethod.POST,
  authenticated: true,
  tokensCodec: t.type({}),
  paramsCodec: t.type({}),
  bodyCodec: t.intersection([
    t.type({
      id: uuidCodec,
      userId: uuidCodec,
      primarySlug: t.string,
      nonprofitName: t.string,
      firstName: t.string,
      email: t.string,
      metadata: nonprofitAdminEntityMetadataCodec,
    }),
    t.partial({
      sendEmail: t.boolean,
    }),
  ]),
  responseBodyCodec: t.type({}),
});
